// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"4b68e092b0bdd3ad","633":"f229a2d8513457b1","664":"8c881e068dc6def7"}[chunkId] + ".js";
};